import React from "react";
import image1 from "../assets/art1.jpeg";
import image2 from "../assets/art2.png"; // Second image for article 2

function article_1() {
	return {
		date: "7 May 2023",
		title: "Humanoid Robot to Teach Kids Programming and Electronics",
		description:
			"Sharing my journey of using humanoid robots to inspire kids in programming, electronics, and robotics.",
		keywords: [
			"Humanoid Robot",
			"Teaching Kids",
			"Programming",
			"Electronics",
			"STEM Education",
			"Francisco Viteri",
		],
		style: `
      .article-content {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .randImage {
        align-self: center;
        outline: 2px solid red;
      }
      .paragraph {
        margin-bottom: 15px;
      }
    `,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						One of the most exciting parts of my career has been
						introducing children to the world of robotics through
						humanoid robots. Watching their eyes light up when a
						robot responds to their code is priceless. I’ve spent
						hours designing hands-on projects that allow students to
						experiment safely with programming and electronics.
					</div>
					<img
						src={image1}
						alt="Humanoid Robot Teaching Kids"
						className="randImage"
					/>
					<br />
					<div className="paragraph">
						I remember one session where a student programmed a
						robot to follow a simple path using sensors. The moment
						the robot moved exactly as intended, the excitement in
						the room was contagious. Moments like these remind me
						why I chose this path — seeing students connect theory
						with tangible results is incredibly rewarding.
					</div>

					<div className="paragraph">
						Over time, I’ve learned that patience, encouragement,
						and creating small achievable goals are key. It’s not
						just about teaching coding or circuits — it’s about
						building confidence, problem-solving skills, and a
						genuine curiosity for STEM subjects in young minds.
					</div>
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "7 May 2023",
		title: "My Experience Teaching Future Generations",
		description:
			"A personal account of my journey teaching robotics, programming, and electronics to inspire students.",
		keywords: [
			"STEM Education",
			"Robotics",
			"Programming",
			"Teaching Experience",
			"Francisco Viteri",
		],
		style: `
      .article-content {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .randImage {
        align-self: center;
        outline: 2px solid red;
      }
      .paragraph {
        margin-bottom: 15px;
      }
    `,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						Teaching has been one of the most fulfilling aspects of
						my professional life. Over the years, I’ve guided
						students through robotics projects, electronics
						experiments, and programming exercises, helping them
						transform curiosity into real skills.
					</div>
					<img
						src={image2}
						alt="Teaching Future Generations"
						className="randImage"
					/>
					<br />
					<div className="paragraph">
						I’ve seen students struggle at first, unsure how
						circuits or code work. But after breaking down concepts
						into hands-on projects, they start experimenting,
						failing, and learning — and their growth is amazing.
						Watching them succeed, sometimes even surpassing their
						own expectations, is what motivates me to keep teaching.
					</div>
					<div className="paragraph">
						Beyond technical skills, I focus on encouraging
						creativity, critical thinking, and persistence. These
						lessons extend beyond the classroom and help students
						approach challenges with confidence. Sharing my
						experience and seeing others ignite their passion for
						STEM is truly rewarding.
					</div>
				</div>
			</React.Fragment>
		),
	};
}

const myArticles = [article_1, article_2];

export default myArticles;
